( () => {

	const inventoryLoadMoreButton = document.querySelector( '#inventory-load-more' );
	const accordionGroup = document.querySelector( '#accordionGroup' );
	const storiesLoadMore = document.querySelector( '#inventory-load-more' );

	const applyFiltersButton = document.querySelector( '#temp-button' );

	const indicatorCounter = document.querySelector( '#inventory-counter' );

	const makeCountHtml = () => {
		indicatorCounter.innerHTML = `<p>Displaying <span class="">${beam_urls.numberShowing}</span> of <span class="">${beam_urls.item_count}</span> diamonds.</p>`;	
	}

	const loadMoreStuff = () => {
		const accordionButtons = document.querySelectorAll( '.accordion__button' );
		const accordionSections = document.querySelectorAll( '.accordion__section' );

		//select diamonds interaction
		const selectDiamondCheckbox = document.querySelectorAll('.select-diamond-input');

		selectDiamondCheckbox.forEach(checkbox => {
			const diamondId = checkbox.dataset.diamondId;

			if (selectedDiamonds.includes(diamondId)) {
				checkbox.checked = true;
			};

			checkbox.addEventListener('click', () => {
				// console.log('clicked checkbox ' + diamondId);
				// console.log(posts_CONST);
				if (checkbox.checked) {
					console.log('checked')
					selectedDiamonds.push(diamondId);
				} else {
					console.log('not checked ok')
					// selectedDiamonds.filter(function(e) { return e !== diamondId })
					selectedDiamonds.indexOf(diamondId) !== -1 && selectedDiamonds.splice(selectedDiamonds.indexOf(diamondId), 1)
				};
				console.log(selectedDiamonds);
			});
		});

		// //select visible
		const selectVisibleButton = document.querySelectorAll('.diamond-select-all');
		const deselectVisibleButton = document.querySelectorAll('.diamond-deselect-all');
		selectVisibleButton.forEach(button => { 
			button.addEventListener('click', () => {
				const selectDiamondCheckbox = document.querySelectorAll('.select-diamond-input');
				console.log('get all visible diamonds');
				selectDiamondCheckbox.forEach(checkbox => {
					const diamondId = checkbox.dataset.diamondId;
					checkbox.checked = true;
					if (!selectedDiamonds.includes(diamondId)) {
						selectedDiamonds.push(diamondId);
					};
				});
				console.log(selectedDiamonds);
			});
		});

		deselectVisibleButton.forEach(button => { 
			button.addEventListener('click', () => {
				const selectDiamondCheckbox = document.querySelectorAll('.select-diamond-input');
				console.log('get all visible diamonds');
				selectDiamondCheckbox.forEach(checkbox => {
					if (checkbox.checked = true) {

						const diamondId = checkbox.dataset.diamondId;
						if (selectedDiamonds.includes(diamondId)) {
							selectedDiamonds.indexOf(diamondId) !== -1 && selectedDiamonds.splice(selectedDiamonds.indexOf(diamondId), 1)
						};
						checkbox.checked = false;
					};
					
				});
				console.log(selectedDiamonds);
			});
		});


		accordionSections.forEach( section =>  {
			section.setAttribute( 'aria-hidden', true );
			// section.classList.remove('open')
		} );

		accordionButtons.forEach( button => {
			button.setAttribute( 'aria-expanded', false );

			const expanded = button.getAttribute( 'aria-expanded' );
			const number = button.getAttribute( 'id' ).split( '-' ).pop();
			const associatedSection = document.getElementById( `accordion-section-${number}` );
			const associatedWrapper = document.getElementById(`diamond-accordion-wrapper-${number}`)

			button.addEventListener( 'click', function() {
				// console.log('button clickèd');
				button.classList.toggle( 'expanded' );
				associatedSection.classList.toggle( 'open' );
				associatedWrapper.classList.toggle('open');
				if ( button.classList.contains( 'expanded' ) ) {
					button.setAttribute( 'aria-expanded', true );
					associatedSection.setAttribute( 'aria-hidden', false );
				} else {
					button.setAttribute( 'aria-expanded', false );
					associatedSection.setAttribute( 'aria-hidden', true );
				}
			} );
		} );

		// if ( parseInt( inventory.currentChunk ) >= parseInt( inventory.maxChunks ) ) {
		// 	// inventoryLoadMoreButton.remove();
		// 	inventoryLoadMoreButton.innerHTML = 'No more inventory to show';
		// 	inventoryLoadMoreButton.disabled = true;
		// } else {
		// 	inventoryLoadMoreButton.innerHTML = 'Load more';
		// 	inventoryLoadMoreButton.disabled = false;
		// }
	};

	// const priceValue = () => {
	// 	// const priceToggle = document.querySelector( '#price-toggle' );
	// 	const priceTogglePressed = priceToggle.getAttribute( 'aria-pressed' );
	// 	const inventoryWrapper = document.querySelector( '.inventory-wrapper' );
	// 	console.log( priceTogglePressed );
	// 	if ( priceTogglePressed === 'true' ) {
	// 		if ( inventoryWrapper.classList.contains( 'inventory-hide-price' ) ) {
	// 			inventoryWrapper.classList.add( 'inventory-show-price' );
	// 			inventoryWrapper.classList.remove( 'inventory-hide-price' );
	// 		}
	// 	} else if ( priceTogglePressed === 'false' ) {
	// 		if ( inventoryWrapper.classList.contains( 'inventory-show-price' ) ) {
	// 			inventoryWrapper.classList.add( 'inventory-hide-price' );
	// 			inventoryWrapper.classList.remove( 'inventory-show-price' );
	// 		}
	// 	}
	// };

		
	

	if ( inventoryLoadMoreButton && accordionGroup ) {
		const worker = new Worker( `${beam_urls.themeUrl}/assets/js/inventory-filter-worker.js` );

		fetch(`${beam_urls.themeUrl}/api-json/beam-data.json`)
			.then(response => response.json())
			.then(json => {

				const productCount = json.length;

				beam_urls = {
					...beam_urls,
					posts_NEW: JSON.stringify(json),
					posts_NEW_UNSORTED: JSON.stringify(json),
					posts_CONST: JSON.stringify(json),
					item_count: productCount,
					max_page: Math.ceil(productCount / parseInt(beam_urls.posts_per_page)),
				};


				const initialPopulationFunction = () => {

					const data = { action: 'filter', config: JSON.stringify( gatherFilterValues() ), stringifiedItems: beam_urls.posts_CONST };

					worker.postMessage( data );

					storiesLoadMore.setAttribute( 'disabled', true );
					applyFiltersButton.setAttribute( 'disabled', true );



					worker.onmessage = ( { data } ) => {
						beam_urls.current_page = 1;
						beam_urls.item_count = data.itemCount;
						beam_urls.posts_NEW = data.items;
						beam_urls.posts_NEW_UNSORTED = data.items;
						beam_urls.max_page = data.maxPage;
						beam_urls.numberShowing = Math.min(beam_urls.posts_per_page, data.itemCount);

						makeCountHtml();

						storiesLoadMore.removeAttribute( 'disabled' );
						applyFiltersButton.removeAttribute( 'disabled' );

						if ( beam_urls.current_page == beam_urls.max_page ) {
							storiesLoadMore.classList.add( 'no-more-products' );
						} else {
							storiesLoadMore.classList.remove( 'no-more-products' );
						}

						accordionGroup.innerHTML = data.firstChunkHtml || '<p class="inventory-no-results">No results found. Please try another search combination.</p>';

						if ( data.firstChunkHtml ) {
							loadMoreStuff();
						} else {
							storiesLoadMore.classList.add( 'no-more-products' );
						}
					};

					worker.onerror = ( error ) => {
						console.log( 'Worker error (' + data.action + '): ' + error.message + '\n' );
						throw error;
					};

				}

				initialPopulationFunction();



				inventoryLoadMoreButton.addEventListener( 'click', () => {
					const data = { action: 'loadMore', config: JSON.stringify( { currentPage: beam_urls.current_page, postsPerPage: beam_urls.posts_per_page } ), stringifiedItems: beam_urls.posts_NEW };
					worker.postMessage( data );

					storiesLoadMore.setAttribute( 'disabled', true );
					applyFiltersButton.setAttribute( 'disabled', true );


					worker.onmessage = ( { data } ) => {
						beam_urls.current_page++;
						beam_urls.numberShowing = Math.min((beam_urls.posts_per_page * beam_urls.current_page), beam_urls.item_count);

						makeCountHtml();

						storiesLoadMore.removeAttribute( 'disabled' );
						applyFiltersButton.removeAttribute( 'disabled' );

						if ( beam_urls.current_page == beam_urls.max_page ) {
							storiesLoadMore.classList.add( 'no-more-products' );
						}

						accordionGroup.innerHTML = accordionGroup.innerHTML + data;
						loadMoreStuff();
					};

					worker.onerror = ( error ) => {
						console.log( 'Worker error (' + data.action + '): ' + error.message + '\n' );
						throw error;
					};

				} );
			});
		
		fetch(`${beam_urls.themeUrl}/api-json/beam-data-temp-all-csv-source.json`)
			.then((response) => response.json())
  			.then((data) => {
  				beam_urls = {
					...beam_urls,
					selectedCsvSource: JSON.stringify(data),
				};
  			});	
  		fetch(`${beam_urls.themeUrl}/api-json/beam-data-temp-all-np-csv-source.json`)
			.then((response) => response.json())
  			.then((data) => {
  				beam_urls = {
					...beam_urls,
					selectedCsvSourceNp: JSON.stringify(data),
				};
  			});		


		








		// INPUTS
		const shapeControl = document.getElementsByName( 'inventory-shape' );
		const caratControl = document.querySelector( '#carat-slider' );
		const colorControl = document.querySelector( '#color-slider' );
		const clarityControl = document.getElementsByName( 'inventory-clairity' );
		const cutControl = document.getElementsByName( 'inventory-cut' );
		const labControl = document.getElementsByName( 'inventory-lab' );
		const inventoryControl = document.getElementsByName( 'inventory-source' );
		const inventoryAvail = document.getElementsByName( 'inventory-availability' );
		const inventorySelect = document.getElementsByName( 'inventory-selected' );
		const inventorySort = document.querySelectorAll( '.inventory-sort' );

		let sortCategory;
		let sortOrder;

		if (inventorySort) {
			inventorySort.forEach(button => { 
				button.addEventListener('click', event => {
					console.log(button);

					sortCategory = button.id;

			

					if (button.classList.contains('inventory-sort-none')) {
						button.classList.remove('inventory-sort-none');
						button.classList.add('inventory-sort-up');
						sortOrder = 'up';
					} else if (button.classList.contains('inventory-sort-up')) {
						button.classList.remove('inventory-sort-up');
						button.classList.add('inventory-sort-down');
						sortOrder = 'down';
					} else if (button.classList.contains('inventory-sort-down')) {
						button.classList.remove('inventory-sort-down');
						button.classList.add('inventory-sort-none');
						sortOrder = 'none';
					} else {
						//do nothing
						sortOrder = 'none';
					};


					for(var i = 0; i < inventorySort.length; i++){
      					if(event.currentTarget != inventorySort[i]){ // check here
        					if (inventorySort[i].classList.contains('inventory-sort-up')) {
        						inventorySort[i].classList.remove('inventory-sort-up');
								inventorySort[i].classList.add('inventory-sort-none');
        					};
        					if (inventorySort[i].classList.contains('inventory-sort-down')) {
        						inventorySort[i].classList.remove('inventory-sort-down');
								inventorySort[i].classList.add('inventory-sort-none');
        					};
      					}
    				}


					const data = { action: 'sortByColumn', config: JSON.stringify({
							numberShowing: beam_urls.numberShowing,
							postsPerPage: beam_urls.posts_per_page,
							order: sortOrder,
							column: sortCategory,
						}), stringifiedItems: beam_urls.posts_NEW, unsortedStringifiedItems: beam_urls.posts_NEW_UNSORTED };

					worker.postMessage( data );

					storiesLoadMore.setAttribute( 'disabled', true );
					applyFiltersButton.setAttribute( 'disabled', true );



					worker.onmessage = ( { data } ) => {
						beam_urls.posts_NEW = data.items;

						makeCountHtml();

						storiesLoadMore.removeAttribute( 'disabled' );
						applyFiltersButton.removeAttribute( 'disabled' );

						if ( beam_urls.current_page == beam_urls.max_page ) {
							storiesLoadMore.classList.add( 'no-more-products' );
						} else {
							storiesLoadMore.classList.remove( 'no-more-products' );
						}

						accordionGroup.innerHTML = data.firstChunkHtml || '<p class="inventory-no-results">No results found. Please try another search combination.</p>';

						if ( data.firstChunkHtml ) {
							loadMoreStuff();
						} else {
							storiesLoadMore.classList.add( 'no-more-products' );
						}
					};

					worker.onerror = ( error ) => {
						console.log( 'Worker error (' + data.action + '): ' + error.message + '\n' );
						throw error;
					};


				});
			})
		};
		

		// FUNCTIONS
		const getChecked = ( checkboxNodeList ) => Array.from( checkboxNodeList ).filter( checkbox => checkbox.checked ).map( checkbox => checkbox.value );
		const getSliderSelection = ( sliderElement ) => sliderElement.noUiSlider.get( true );
		const gatherFilterValues = () => {
			const filterConfig = {
				postsPerPage: beam_urls.posts_per_page,
				shapeConfig: getChecked( shapeControl ),
				caratConfig: getSliderSelection( caratControl ),
				colorConfig: getSliderSelection( colorControl ),
				clarityConfig: getChecked( clarityControl ),
				cutConfig: getChecked( cutControl ),
				labConfig: getChecked( labControl ),
				inventoryConfig: getChecked( inventoryControl ),
				availabilityConfig: getChecked( inventoryAvail ),
				selectConfig: getChecked( inventorySelect ),
				ids: selectedDiamonds,
			};

			Object.keys( filterConfig ).forEach( key => !filterConfig[ key ].length ? delete filterConfig[ key ] : {} );
			console.log(filterConfig)
			return filterConfig;
		};


		// TEMP



		applyFiltersButton.addEventListener( 'click', () => {
			const data = { action: 'filter', config: JSON.stringify( gatherFilterValues() ), stringifiedItems: beam_urls.posts_CONST };
			worker.postMessage( data );

			storiesLoadMore.setAttribute( 'disabled', true );
			applyFiltersButton.setAttribute( 'disabled', true );



			worker.onmessage = ( { data } ) => {
				beam_urls.current_page = 1;
				beam_urls.item_count = data.itemCount;
				beam_urls.posts_NEW = data.items;
				beam_urls.posts_NEW_UNSORTED = data.items;
				beam_urls.max_page = data.maxPage;
				beam_urls.numberShowing = Math.min(beam_urls.posts_per_page, data.itemCount);

				makeCountHtml();

				storiesLoadMore.removeAttribute( 'disabled' );
				applyFiltersButton.removeAttribute( 'disabled' );

				if ( beam_urls.current_page == beam_urls.max_page ) {
					storiesLoadMore.classList.add( 'no-more-products' );
				} else {
					storiesLoadMore.classList.remove( 'no-more-products' );
				}

				accordionGroup.innerHTML = data.firstChunkHtml || '<p class="inventory-no-results">No results found. Please try another search combination.</p>';

				if ( data.firstChunkHtml ) {
					loadMoreStuff();
				} else {
					storiesLoadMore.classList.add( 'no-more-products' );
				}
			};

			worker.onerror = ( error ) => {
				console.log( 'Worker error (' + data.action + '): ' + error.message + '\n' );
				throw error;
			};

		} );
	}
	//init toggle
	var selector = '[data-switch-toggle]';
	var elList = document.querySelectorAll( selector );
	var i;

	for ( i = 0; i < elList.length; i++ ) {
		var a11ybtn = new A11yToggleButton();
		a11ybtn.init( elList[ i ] );
	}
	//listen for price click

} )();
